import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { backButton } from '@telegram-apps/sdk-react';

/** Нативная кнопка «назад» Telegram видна на всех экранах, кроме корневого. */
export function BackButtonSync() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isRoot = location.pathname === '/';
    try {
      if (isRoot) backButton.hide();
      else backButton.show();
    } catch {
      /* недоступно вне Telegram */
    }
  }, [location.pathname]);

  useEffect(() => {
    try {
      return backButton.onClick(() => void navigate(-1));
    } catch {
      return undefined;
    }
  }, [navigate]);

  return null;
}
